(function () {
	'use strict';
	angular.module('app.leanProjects')
		.controller('viewProjects', viewProjects);

	viewProjects.$inject = ['$scope', '$rootScope', '$timeout', '$q', '$state', '$uibModal', '$location', '$translate',
		'$experiments', 'redirectParamsService', 'leanProjectsService', 'leanFilterService', 'leanTableService', 'tableRenderService', 'tableService',
		'a3ModalService', 'viewProjectsService', 'pageTimingService', 'currencyFormatService',
		'storeService'
	];

	function viewProjects($scope, $rootScope, $timeout, $q, $state, $uibModal, $location, $translate,
			$experiments, redirectParamsService, leanProjectsService, leanFilterService, leanTableService, tableRenderService,
			tableService, a3ModalService, viewProjectsService, pageTimingService, currencyFormatService,
			storeService) {
		var vm = this;
		var unsubscribe;
		var currentState = $state.current;
		var pageType = currentState.data.viewType;
		var defaultColumns = [];
		var completeWidthMap = {};
		var reportSettingsName;
		var viewLink = '/application/f/home.html#/lean-projects/edit-project?fromLocation=viewProjects&projectNdx=';
		var defaultSort = 'dueDate';
		var hideSearch = false;
		var hideFilters = false;
		var defaultFilters = [];
		var extraParams = [{
			'name': 'includeAllStages',
			'value': true,
			excelReportName: 'ViewProjects'
		}];
		var getDataCalled = false;
		var showRowsCalled = false;
		var timingCalled = false;
		var HEADER_TOTAL_COLUMNS_ID = ['targetSavings', 'actualSavings'];
		function getYtdTranslatedText(key) {
			return $translate.instant(key);
		}
		vm.isSupplier = globalConfig.user.role == 'Supplier';
		var reportName;

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		setProjectDefaultSettings();

		var columns = getProjectColumns();
		defaultColumns = _.map(columns, _.clone);


		vm.actionButtonText = 'Add Project';
		vm.actionButtonIcon = 'AddItem';
		vm.actionButtonPreventRefocus = true;
		vm.broadcastAction = broadcastAction;
		vm.broadcastExcel = broadcastExcel;
		vm.getData = getData;
		vm.getMeta = getMeta;
		vm.initialLoad = true;
		vm.openNewProject = openNewProject;
		vm.searchPlaceholderText = 'projectSearch.search.placeholder';
		vm.showActionButton = !vm.isSupplier;
		vm.showExcel = true;
		vm.stageListMap = {};
		vm.reportName = vm.reportTitle;
		vm.approveProject = approveProject;
		vm.deleteProject = deleteProject;
		vm.archiveProject = archiveProject;
		vm.viewA3Report = viewA3Report;
		$scope.openNewProject = openNewProject;
		vm.SUPPLIER_COMPONENT = pageType === 'supplierProjects' ? 'PROJECTS' : null;

		var pinnedColumns = [];

		var rendererParams = {
			columns: columns,
			stageListMap: vm.stageListMap,
			completeWidthMap: completeWidthMap,
			viewLink: viewLink
		};

		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportName: vm.reportName,
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: defaultSort,
			rendererParams: rendererParams,
			pageSize: 50,
			reportUrl: '{0}/ViewProjects',
			searchType: 'project',
			viewLink: viewLink,
			extraParams: extraParams,
			hideSearch: hideSearch,
			controllerHandlesFilterLoad: true,
			hideFilters: hideFilters,
			useBackendCurrencyConversion: true,
			setColumnDefaults: true,
			excelRequest: true,
			hasMandatoryFilters: true
		};

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('View Projects');
				timingCalled = true;
			}
		}

		function updateExtraParams(extraParams) {
			if (pageType == 'approveProjects') {
				extraParams.push({
					name: 'projectStageName',
					value: 'Pending Approval'
				});
			}
		}

		function tableServiceGetData(params, extraParams, isFilterChanged) {
			updateExtraParams(extraParams);
			return tableService.getData(params, extraParams, isFilterChanged).then(function (response) {
				return tableServiceGetDataSuccess(response, isFilterChanged);
			});
		}

		function tableServiceGetDataSuccess(response, isFilterChanged) {
			// If any data manipulation is needed, do it here
			if ((isFilterChanged && isFilterChanged === 'filtersChanged') || vm.initialLoad) {
				if (vm.initialLoad) {
					vm.initialLoad = false;
					processCustomFields(response);
					processProjectSavingsFields(response);
				}

				setVisibilityChanged(columns);
				response.refreshMeta = true;
			}
			if (response && response[0] && response[0].stagesBySite) {
				processStages(response[0].stagesBySite);
			}

			setHeaderTotals(response);
			getDataCalled = true;
			submitUserTiming();
			return response;
		}

		function setHeaderTotals(response) {
			if (!response[0]) {
				return;
			}
			if (response[1].hasOwnProperty('ytdTargetSavingsTotal') && response[1].hasOwnProperty('ytdActualSavingsTotal')) {
				var ytdTargetSavingsTotal = response[1]['ytdTargetSavingsTotal'];
				var ytdActualSavingsTotal = response[1]['ytdActualSavingsTotal'];
				var column = getColumn('ytdTargetSavings');
				var currencyFormattedString = '';
				if (column && ytdTargetSavingsTotal !== 0) {
					currencyFormattedString = ': ' + convertToCurrency(ytdTargetSavingsTotal, response[0].targetCurrency);
					column.display = getYtdTranslatedText('YTD Target Savings') + currencyFormattedString;
					column.displayText = getYtdTranslatedText('YTD Target Savings');
				} else {
					column.display = getYtdTranslatedText('YTD Target Savings');
					column.displayText = column.display;
				}

				column = getColumn('ytdActualSavings');
				if (column && ytdActualSavingsTotal !== 0) {
					currencyFormattedString = ': ' + convertToCurrency(ytdActualSavingsTotal, response[0].targetCurrency);
					column.display = getYtdTranslatedText('YTD Actual Savings') + currencyFormattedString;
					column.displayText = getYtdTranslatedText('YTD Actual Savings');
				} else {
					column.display = getYtdTranslatedText('YTD Actual Savings');
					column.displayText = column.display;
				}

				column = getColumn('deltaYTD');
				var difference = ytdActualSavingsTotal - ytdTargetSavingsTotal;
				if (column && difference !== 0) {
					currencyFormattedString = ': ' + convertToCurrency(difference, response[0].targetCurrency);
					column.display = getYtdTranslatedText('YTD Actual Savings Diff') + currencyFormattedString;
					column.displayText = getYtdTranslatedText('YTD Actual Savings Diff');
				} else {
					column.display = getYtdTranslatedText('YTD Actual Savings Diff');
					column.displayText = column.display;
				}
			}
			addHeaderTotals(response[1], response[0].targetCurrency);
		}

		function addHeaderTotals(response, currency) {
			var column = '';
			var currencyFormattedString = '';
			var savingsCategoryFields = [];
			angular.forEach(vm.projectSavingsCategoryList, function (projectSavingsCategoryField) {
				var projectSavingsCategoryFieldId = 'psc_' + projectSavingsCategoryField.id + '_' + projectSavingsCategoryField.savingType;
				savingsCategoryFields.push(projectSavingsCategoryFieldId + '_target');
				savingsCategoryFields.push(projectSavingsCategoryFieldId + '_actual');
			});
			var headerTotalCols = HEADER_TOTAL_COLUMNS_ID.concat(savingsCategoryFields);
			angular.forEach(headerTotalCols, function(columnId) {
				if (response.hasOwnProperty(columnId + 'Total')) {
					column = getColumn(columnId);
					if (column && response[columnId + 'Total'] !== 0) {
						currencyFormattedString = ': ' + convertToCurrency(response[columnId + 'Total'], currency);
						column.display = $translate.instant(column.displayText) + currencyFormattedString;
					} else {
						column.display = column.displayText;
					}
				}
			});
		}

		function processCustomFields(response){
			if (response && response[0] && response[0].customFields) {
				vm.customFieldList =  response[0].customFields;
				vm.customFieldList = _.groupBy(vm.customFieldList, function (customList) {
					return customList.name + '_SEPARATOR_' + customList.fieldType;
				});
			} else {
				vm.customFieldList = [];
			}
			appendCustomFields();
		}

		function processProjectSavingsFields(response){
			if (response && response[0] && response[0].projectSavingsCategoryFields) {
				vm.projectSavingsCategoryList = response[0].projectSavingsCategoryFields;
			} else {
				vm.projectSavingsCategoryList = [];
			}
			appendProjectSavingsFields();
		}

		function processStages(stagesBySites) {
			vm.stageListMap = stagesBySites;
			rendererParams.stageListMap = vm.stageListMap;
			angular.forEach(vm.stageListMap, function (stagesBySite, siteId) {
				completeWidthMap[siteId] = Math.max((stagesBySite.length - 2) * 18 + stagesBySite.length - 1, 58) + 'px';
			});
		}

		function getData(params, extraParams, isFilterChanged) {
			if (vm.resetSort) {
				params.start = 0;
				vm.resetSort = false;
			}
			if ((isFilterChanged && isFilterChanged === 'filtersChanged') || vm.initialLoad) {
				if (vm.initialLoad) {
					$timeout(function () {
						if (reportSettingsName === globalReportName || reportSettingsId === globalReportName) {
							leanFilterService.loadFilters();
						}
					}, 0);
				}
			}
			return tableServiceGetData(params, extraParams, isFilterChanged);
		}

		function getMeta() {
			return meta;
		}

		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		$scope.tableService.setReportSettingsName(reportSettingsName);
		$scope.filterService.searchType = 'project';


		function init() {
			if (vm.isSupplier && $state.current.name === 'app.lean-projects.view-projects') {
				$location.path('/supply-chain/supplier-projects/').replace();
				return;
			}
			$scope.filterService.clearFilters();
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);

			if (_.findIndex(defaultFilters, {'id': 'timePeriod'}) == -1) {
				defaultFilters.push({'id': 'timePeriod', 'value': 'all', 'isMandatory': true});
			}

			var timePeriodFilter = leanFilterService.filterDefinitions['TimePeriod'];
			timePeriodFilter.removable = false;
			if (!(globalConfig.user.role == 'Supplier')) {
				leanFilterService.useFactoryFilter = true;
				var siteFilter = leanFilterService.filterDefinitions['Factory'];
				siteFilter.type = 'multiselect';
				siteFilter.removable = false;

				var filters = [
					$scope.filterService.filterDefinitions.BusinessUnit,
					siteFilter,
					$scope.filterService.filterDefinitions.ProjectArea,
					$scope.filterService.filterDefinitions.ProjectCategories,
					$scope.filterService.filterDefinitions.ProjectManager,
					$scope.filterService.filterDefinitions.ProjectMember,
					$scope.filterService.filterDefinitions.ProjectBestPractice,
					_.assign({}, $scope.filterService.filterDefinitions.ProjectSavingsCategories, { detail: 'Show Projects with actual values for:' })
				];

				if (pageType == 'supplierProjects') {
					filters.push($scope.filterService.filterDefinitions.ProjectStageAll);
					filters.push($scope.filterService.filterDefinitions.Supplier);
				} else if (pageType == 'viewProjects') {
					filters.push($scope.filterService.filterDefinitions.ProjectStageAll);
					filters.push($scope.filterService.filterDefinitions.ProjectTypes);
					filters.push($scope.filterService.filterDefinitions.ProjectGoals);
				} else if (pageType == 'approveProjects') {
					filters.push($scope.filterService.filterDefinitions.ProjectTypes);
				} else if (pageType == 'projectSearch') {
					leanFilterService.useFactoryFilter = true;
					filters = [siteFilter];
				}
				$scope.filterService.setMasterFilterList(filters);
			} else {
				if (pageType != 'approveProjects') {
					$scope.filterService.setMasterFilterList([
						leanFilterService.filterDefinitions['Factory'],
						$scope.filterService.filterDefinitions.ProjectStageAll
					]);
				} else {
					$scope.filterService.setMasterFilterList([]);
				}
			}
			$scope.filterService.setMasterSingleSelectFilterList([
			]);
			$scope.filterService.setMasterRangeFilterList([
				timePeriodFilter
			]);
			leanFilterService.addCustomFieldsFilters();
		}

		function removeAllInvalidCharacters(key) {
			return key.replace(/[^a-zA-Z0-9_]/g, '');
		}

		function appendCustomFields() {
			//Remove columns that are not default
			columns = _.intersectionBy(columns, defaultColumns, 'id');
			var customFieldIds = [];
			angular.forEach(vm.customFieldList, function (customFields, key) {
				var customFieldNameAndType = key.split('_SEPARATOR_');
				var customFieldType = customFieldNameAndType[1];
				var obj = {};
				obj.id = 'cus_' + removeAllInvalidCharacters(key);
				obj.display = customFieldNameAndType[0];
				obj.width = 100;
				if (customFieldType == 'DATE') {
					obj.renderer = tableRenderService.dateRenderer;
					obj.convertTimeZone = true;
				} else if (customFieldType == 'CURRENCY') {
					obj.renderer = tableRenderService.currency;
				}
				obj.enablePinning = false;
				columns.push(obj);
				customFieldIds.push(obj.id);
			});

			meta.columns = columns;
			addMissingColumnsToReportSettings(customFieldIds);
		}

		function getProjectSavingCatergoryField(id, name, type, savingType) {
			var obj = {};
			var headerText = '(' + savingType + ') ' + name + ' ' + type;
			obj.id = id + '_' + type.toLowerCase();
			obj.display = headerText;
			obj.displayText = headerText;
			obj.width = 100;
			obj.renderer = tableRenderService.currency;
			obj.enablePinning = false;
			return obj;
		}

		function appendProjectSavingsFields() {
			var savingsColumnsId = [];
			angular.forEach(vm.projectSavingsCategoryList, function (projectSavingsCategoryField) {
				var projectSavingsCategoryFieldId = 'psc_' + projectSavingsCategoryField.id + '_' + projectSavingsCategoryField.savingType;
				var targetColumn = getProjectSavingCatergoryField(projectSavingsCategoryFieldId, projectSavingsCategoryField.name, 'Target', projectSavingsCategoryField.savingType);
				var actualColumn = getProjectSavingCatergoryField(projectSavingsCategoryFieldId, projectSavingsCategoryField.name, 'Actual', projectSavingsCategoryField.savingType);
				columns.push(targetColumn);
				columns.push(actualColumn);
				savingsColumnsId.push(targetColumn.id);
				savingsColumnsId.push(actualColumn.id);
			});

			meta.columns = columns;
			addMissingColumnsToReportSettings(savingsColumnsId);
		}

		function addMissingColumnsToReportSettings(missingColumns) {
			var isReadOnly = storeService.getState().reportSettings.readOnly === true;
			var tableConfig = storeService.getState().reportSettings.columns.map(function (col) {
				return col.name;
			});
			var resolutionVal = getResolutionVal();
			var newColumns = [];
			for (var i = 0; i < missingColumns.length; i++) {
				if (tableConfig.indexOf(missingColumns[i]) === -1) {
					var colDef = {
						name: missingColumns[i],
						show: false,
						width: {},
						grouped: false
					};
					colDef.width[resolutionVal] = 100;
					newColumns.push(colDef);
				}
			}

			storeService.dispatch({
				type: storeService.actions.COLUMNS_ADD_NEW,
				payload: {
					newColumns: newColumns
				},
				meta: {
					reportName: reportSettingsName,
					reportSettingsId: vm.getMeta().reportSettingsId,
					doNotSave: isReadOnly,
					userModified: false
				}
			});
		}

		function viewA3Report(projNdx, factoryNdx) {
			if (!factoryNdx) {
				factoryNdx = globalConfig.factory.id;
			}
			var modalInstance = a3ModalService.openModal(projNdx, factoryNdx);

			modalInstance.result.finally(function () {
				a3ModalService.removeNoPrintClass();
			});
		}

		function openNewProject() {
			var newProjectScope = $scope.$new();
			newProjectScope.isSupplierProject = pageType == 'supplierProjects';
			newProjectScope.filterService = $scope.filterService;

			var opts = {
				scope: newProjectScope,
				templateUrl: '/application/f/lean-projects/new-project/new-project.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			newProjectScope.closeDialog = function () {
				instance.close();
				newProjectScope.$destroy();
			};

			newProjectScope.result = function (message, isSuccessful, stageId) {
				instance.close();
				newProjectScope.$destroy();
				var time = 3000;
				if (isSuccessful) {
					addStageIdToFilter(stageId);
				}
				$rootScope.$emit('toast', {
					'message': message,
					'success': isSuccessful,
					'time': time
				});
				if (isSuccessful) vm.reloadTable();
			};

			newProjectScope.addToastMessage = function (message, type) {
				$rootScope.$emit('toast', {
					'message': message,
					'success': type
				});
			};
		}

		function approveProject(projNdx, lastModified, factoryNdx) {
			var stageObj = vm.stageListMap[factoryNdx][1];
			saveProject(projNdx, lastModified, stageObj, 'approved', 'approve this project', 'Approve', factoryNdx);
		}

		function deleteProject(projNdx, lastModified, factoryNdx) {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = 'delete this project';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();

				leanProjectsService.deleteProject(projNdx, factoryNdx).then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Project deleted successfully'
						});
						$scope.$broadcast('reloadTable');
					} else {
						$rootScope.$emit('toast', {
							'message': 'Project deleted successfully',
							'success': false
						});
					}
				});
			};
		}

		function archiveProject(projNdx, lastModified, factoryNdx) {
			var stageObj = vm.stageListMap[factoryNdx][vm.stageListMap[factoryNdx].length - 1];
			saveProject(projNdx, lastModified, stageObj, 'archived', 'archive this project', 'Archive', factoryNdx);
		}

		function viewA3Report(projNdx, factoryNdx) {
			if (!factoryNdx) {
				factoryNdx = globalConfig.factory.id;
			}
			var modalInstance = a3ModalService.openModal(projNdx, factoryNdx);

			modalInstance.result.finally(function () {
				a3ModalService.removeNoPrintClass();
			});
		}

		function getStages(factoryNdx) {
			return $scope.stageListMap[factoryNdx];
		}

		function saveProject(projNdx, lastModified, stageObj, action, additionalText, buttonText, factoryNdx) {
			if (!factoryNdx) factoryNdx = globalConfig.factory.id;
			var confirmScope = $scope.$new();
			confirmScope.additionalText = additionalText;
			confirmScope.buttonText = buttonText;
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				var projObj = {};
				projObj.id = projNdx;
				projObj.stageId = stageObj.id;
				projObj.stageSequence = stageObj.stageSequence;
				viewProjectsService.saveProject(projObj, factoryNdx,
					(new Date(lastModified)).toUTCString())
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {
								'message': 'Project ' + action + ' successfully'
							});
							$scope.$broadcast('reloadTable');
						} else if (response && response.status == 412) {
							var errorMessage = 'This project has been updated since you loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {
								'message': errorMessage,
								'success': false
							});
						} else {
							$rootScope.$emit('toast', {
								'message': 'Unexpected server errror',
								'success': false
							});
						}
					});
			};
		}

		function addStageIdToFilter(stageId) {
			var stageFilter = $scope.filterService.getFilterById('projectStageId');
			var filterApplied = false;
			for (var i = 0; i < stageFilter.objectList.length; i++) {
				var stageIds = _.split(stageFilter.objectList[i].id.toString(), ',').map(function(id) {
					return parseInt(id);
				});
				if (_.indexOf(stageIds, stageId) !== -1) {
					if (!stageFilter.objectList[i].selected) {
						stageFilter.objectList[i].selected = true;
						filterApplied = true;
						stageFilter.values = $scope.filterService.getSelectedIds('projectStageId');
						storeService.updateFilterSettings(stageFilter, reportSettingsName, reportSettingsId, true);
						$scope.filterService.updateActiveFiltersRedux();
					}
					break;
				}
			}
			return filterApplied;
		}

		function broadcastAction() {
			openNewProject();
		}

		function openNewProject() {
			var newProjectScope = $scope.$new();
			newProjectScope.isSupplierProject = pageType == 'supplierProjects';
			newProjectScope.filterService = $scope.filterService;

			// Build list of stages
			var stageFilter = vm.stageListMap[globalConfig.factory.id];
			if (stageFilter && stageFilter.length) {
				newProjectScope.stageList = stageFilter.map(function (obj) {
					return {
						'name': obj.name,
						'id': obj.id
					};
				});
			}

			var opts = {
				scope: newProjectScope,
				templateUrl: '/application/f/lean-projects/new-project/new-project.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			newProjectScope.closeDialog = function () {
				instance.close();
				newProjectScope.$destroy();
			};

			newProjectScope.result = function (message, isSuccessful, stageId) {
				instance.close();
				newProjectScope.$destroy();
				var time = 3000;
				if (isSuccessful) {
					vm.resetSort = addStageIdToFilter(stageId);
				}
				$rootScope.$emit('toast', {
					'message': message,
					'success': isSuccessful,
					'time': time
				});
				if (isSuccessful) $scope.$broadcast('reloadTable', vm.resetSort ? {'start': 0}: undefined);
			};

			newProjectScope.addToastMessage = function (message, type) {
				$rootScope.$emit('toast', {
					'message': message,
					'success': type
				});
			};
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true, exportFileName: pageType == 'supplierProjects' && reportSettingsId ? vm.reportName : undefined});
		}

		function getProjectColumns() {
			var projectColumns = [{
				'id': 'name',
				'display': 'Name',
				'width': 240,
				'renderer': tableRenderService.projectNameRenderer,
				'pinnedLeft': true
			},
			{
				'id': 'factoryName',
				'display': 'Site',
				'class': 'supplierCell',
				'width': 100
			},
			{
				'id': 'lastUpdate',
				'display': 'Last Update',
				'class': 'buyerCell',
				'width': 180,
				'renderer': tableRenderService.relativeDate
			},
			{
				'id': 'area',
				'display': 'Area',
				'class': 'buyerCell',
				'width': 120
			},
			{
				'id': 'category',
				'display': 'Category',
				'class': 'buyerCell',
				'width': 150
			},
			{
				'id': 'stageSequence',
				'display': 'Stage',
				'class': 'buyerCell',
				'width': 150,
				'renderer': tableRenderService.projectStageRenderer
			}
			];
			if (pageType == 'supplierProjects') {
				projectColumns.push({
					'id': 'supplierName',
					'display': 'Supplier Name',
					'width': 200,
					'class': 'buyerCell'
				});
			} else if (pageType == 'viewProjects' || pageType == 'approveProjects' || pageType == 'projectSearch') {
				projectColumns.push({
					'id': 'businessUnit',
					'display': 'Business Unit',
					'show':false,
					'width': 240,
					'sort': true
				});
				projectColumns.push({
					'id': 'projectType',
					'display': 'Project Type',
					'width': 140,
					'class': 'buyerCell',
					'translate': true
				});
			}
			projectColumns.push({
				'id': 'projectStartDate',
				'display': 'Start Date',
				'show': false,
				'width': 100,
				'convertTimeZone': true,
				'renderer': tableRenderService.dateRenderer
			});
			projectColumns.push({
				'id': 'dueDate',
				'display': 'Due Date',
				'width': 100,
				'class': 'buyerCell',
				'convertTimeZone': true,
				'renderer': tableRenderService.projectDueDateRenderer
			});
			projectColumns.push({
				'id': 'dateCreated',
				'display': 'Created (Days)',
				'show': false,
				'width': 100,
				'class': 'buyerCell',
				'renderer': tableRenderService.daysOffset
			});
			projectColumns.push({
				'id': 'startDate',
				'display': 'Started (Days)',
				'show': false,
				'width': 100,
				'class': 'buyerCell',
				'renderer': tableRenderService.daysOffset
			});
			projectColumns.push({
				'id': 'projectManager',
				'display': 'Project Manager',
				'class': 'buyerCell',
				'width': 140,
				'renderer': tableRenderService.projectManagerRenderer
			});
			projectColumns.push({
				'id': 'projectSponsor',
				'display': 'Project Sponsor',
				'width': 140,
				'class': 'buyerCell',
				'show': false
			});
			projectColumns.push({
				'id': 'projectExternalId',
				'display': 'ID',
				'width': 100,
				'class': 'buyerCell',
				'show': false
			});
			projectColumns.push({
				'id': 'templateFlag',
				'display': 'Best Practice',
				'width': 100,
				'class': 'buyerCell',
				'show': false,
				'renderer': tableRenderService.yesNo
			});
			projectColumns.push({
				'id': 'targetSavings',
				'display': 'Target Total Savings',
				'displayText': 'Target Total Savings',
				'width': 140,
				'class': 'buyerCell',
				'renderer': tableRenderService.currency,
				'show': false
			});
			projectColumns.push({
				'id': 'actualSavings',
				'display': 'Actual Total Savings',
				'displayText': 'Actual Total Savings',
				'width': 140,
				'class': 'buyerCell',
				'renderer': tableRenderService.currency,
				'show': false
			});
			projectColumns.push({
				'id': 'ytdTargetSavings',
				'display': 'YTD Target Savings',
				'width': 140,
				'class': 'buyerCell',
				'show': true,
				'renderer': tableRenderService.ytdProjectSavingsRenderer
			});
			projectColumns.push({
				'id': 'ytdActualSavings',
				'display': 'YTD Actual Savings',
				'width': 140,
				'class': 'buyerCell',
				'show': true,
				'renderer': tableRenderService.ytdProjectSavingsRenderer
			});
			projectColumns.push({
				'id': 'deltaYTD',
				'display': 'YTD Actual Savings Diff',
				'width': 140,
				'class': 'buyerCell',
				'show': false,
				'renderer': tableRenderService.ytdProjectSavingsDeltaRenderer
			});
			projectColumns.push({
				'id': 'numberOfTasks',
				'display': '# of Open Tasks',
				'width': 100,
				'show': true,
				'sort': true,
				'renderer': tableRenderService.integerZeroIfEmpty
			});
			projectColumns.push({
				'id': 'numberOfIssues',
				'display': '# of Open Issues',
				'width': 100,
				'show': true,
				'sort': true,
				'renderer': tableRenderService.integerZeroIfEmpty
			});
			return projectColumns;
		}

		function setProjectDefaultSettings() {
			if (pageType == 'supplierProjects') {
				reportSettingsName = 'supplier-projects';
				vm.reportTitle = 'Supplier performance projects';
				vm.baseReportDisplay = 'Supplier performance projects';
				extraParams.push({
					'name': 'supplierOnly',
					'value': true
				});
				extraParams.push({
					'name': 'includeSupplier',
					'value': true
				});
				viewLink = '/application/f/home.html#/supply-chain/edit-project?fromLocation=supplierProjects&supplier=1&projectNdx=';
			} else if (pageType == 'viewProjects') {
				reportSettingsName = 'view-projects';
				vm.reportTitle = 'Projects (lean projects)';
				vm.baseReportDisplay = 'Projects (lean projects)';
				
				defaultFilters = [{
					'id': 'timePeriod',
					'value': 'current',
					'isMandatory': true
				}];
			} else if (pageType == 'approveProjects') {
				reportSettingsName = 'approve-projects';
				viewLink = '/application/f/home.html#/lean-projects/edit-project?fromLocation=approveProjects&projectNdx=';
			} else if (pageType == 'projectSearch') {
				reportSettingsName = 'project-search';
				vm.reportTitle = 'Project search';
				defaultFilters = [{
					'id': 'factory',
					'values': [leanFilterService.leanDnaAllSelected]
				}];
				defaultSort = 'name';
				viewLink = '/application/f/home.html#/lean-projects/edit-project?fromLocation=projectSearch&extraParamKey=search&extraParamValue=' +
					$location.search().search + '&projectNdx=';
			}

			if (pageType !== 'projectSearch') {
				defaultFilters.push({'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true});
			}
		}

		function setVisibilityChanged(cols) {
			var tableConfig = storeService.getState().reportSettings;
			for (var i = 0; i < cols.length; i++) {
				var index = findInArray(tableConfig.columns, 'name', cols[i].id);
				if (index >= 0) {
					cols[i].show = tableConfig.columns[index].show;
					cols[i].width = searchWidths(tableConfig, index);
				}
			}
			for (var i = 0; i < meta.pinnedColumns.length; i++) {
				var index = findInArray(tableConfig.columns, 'name', meta.pinnedColumns[i].id);
				if (index >= 0) {
					meta.pinnedColumns[i].show = tableConfig.columns[index].show;
					meta.pinnedColumns[i].width = searchWidths(tableConfig, index);
				}
			}
		}

		function searchWidths(tableConfig, index) {
			var width = tableConfig.columns[index].width.large;
			if (width == undefined) {
				width = tableConfig.columns[index].width.medium;
				if (width == undefined) {
					width = tableConfig.columns[index].width.small;
				}
			}
			return width;
		}

		function convertToCurrency(val, currency) {
			var decimals = undefined;
			var keepAllDecimals = undefined;
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			var formattedVal = val;
			if (val > 10 || val < -10) {
				decimals = 0;
			}
			if (val || val == 0) {
				var val = currencyFormatService.getWithParametersNegativeSign(val, decimals, currency);
				return val;
			}
			return val;
		}

		function getColumn(id, cols) {
			var column;
			if (typeof cols === 'undefined') {
				cols = columns;
			}
			column = _.find(cols, {
				'id': id
			});
			if (!column) {
				cols = pinnedColumns;
				column = _.find(cols, {
					'id': id
				});
			}
			return column;
		}

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}

		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId && pageType !== 'projectSearch';
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			var hasSavedViewType = false;
			if (pageType === 'viewProjects' || pageType === 'approveProjects') {
				hasSavedViewType = reportSettings.viewType === 'savedLeanProjects';
			}
			if (pageType === 'supplierProjects') {
				hasSavedViewType = reportSettings.viewType === 'savedReports';
			}
			if (hasSavedViewType) {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		init();
	}
})();
